"use client";

import { Skeleton } from "@nextui-org/react";
import React from "react";

function HighlightPostSkeleton() {
  return (
    <div className=" w-full grid grid-cols-3 grid-rows-1 gap-x-[32px]">
      <div className="col-span-2">
        <Skeleton className=" w-[1119] h-[414] aspect-[16/9] bg-[#7D7D7D] rounded-[28px] before:!duration-600 before:!bg-opacity-10" />
      </div>
      <div className="col-span-1 flex flex-col justify-between">
        <div className="flex flex-row items-center justify-start space-x-[22px]">
          <Skeleton className="flex rounded-full w-[120px] h-[34px] !bg-[#7D7D7D] before:!duration-600 before:!bg-opacity-10" />
          <Skeleton className="flex rounded-full w-[120px] h-[34px] !bg-[#7D7D7D] before:!duration-600 before:!bg-opacity-10" />
        </div>
        <div className=" flex-col items-start space-y-[40px] !no-underline">
          <div className=" space-y-[16px]">
            <Skeleton className=" h-[28px] w-[80%] !bg-[#7D7D7D] rounded-full before:!duration-600 before:!bg-opacity-10" />
            <Skeleton className=" h-[28px] w-[35%] !bg-[#7D7D7D] rounded-full before:!duration-600 before:!bg-opacity-10" />
          </div>

          <Skeleton className=" h-[28px] w-[60%] !bg-[#7D7D7D] rounded-full before:!duration-600 before:!bg-opacity-10" />
        </div>
      </div>
    </div>
  );
}

export default HighlightPostSkeleton;
